import React, {Component} from 'react';
import {Link} from 'react-router';
import {Table} from 'antd';
import moment from 'moment';
import {queryIncuBusinessArchved} from '@api/incubator/business';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    const { contractTab, condition } = this.props;
    this.condition = condition;
    this.current = contractTab.archivedPage || 1;
    this.getIncuBusinessArchved();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(key => nextProps.condition[key] !== this.condition[key])
    ) {
      this.condition = nextProps.condition;
      this.getIncuBusinessArchved();
    }
  }

  getIncuBusinessArchved = () => {
    this.setState({
      loading: true,
    });
    const { pageSize } = this.props;
    queryIncuBusinessArchved({
      type: 'oregistapp',
      limit: pageSize,
      start: this.current || 1,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.props.onPageChange('oregistapp', this.current);
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize,
              current: this.current,
            },
          },
          loading: false,
        });
      }
    });
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.getIncuBusinessArchved();
  };

  columns = () => {
    const termType = ['提前终止', '异常终止'];
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.uuid}/address/info`}>{record.no}</Link>
        ),
      },
      {
        title: '企业名称',
        dataIndex: 'custom',
      },
      {
        title: '合同周期',
        dataIndex: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '注册数',
        dataIndex: 'num',
      },
      {
        title: '收费类型',
        dataIndex: 'itemType',
        width: 100,
        render: text => (text === 0 ? '免费' : '收费'),
      },
      {
        title: '合同情况',
        dataIndex: 'termType',
        width: 150,
        render: text => <span>{termType[text] || '正常'}</span>,
      },
      {
        title: '合同归档时间',
        dataIndex: 'archiveDate',
        render: (text, record) => {
          const diff = Math.floor((text - record.endDate) / 86400000);

          return (
            <div>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}
              <p style={{ marginBottom: '0' }}>{diff < 0 ? `（提前${Math.abs(diff)}天）` : ''}</p>
              <p style={{ color: 'red', marginBottom: '0' }}>
                {diff > 0 ? `（逾期${Math.abs(diff)}天）` : ''}
              </p>
            </div>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.uuid}/address/info`}>查看</Link>
        ),
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.state;
    const expandedRowRender = record => <span>{record.termReason}</span>;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        onChange={this.onTableChange}
        expandedRowRender={expandedRowRender}
        loading={loading}
      />
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/address/TableArchived.js